import { motion } from "framer-motion";
import { Phone, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/siteData";

const links = [
  { label: "Savoir-faire", href: "#savoir-faire", testId: "nav-link-manifesto" },
  { label: "Galerie", href: "#galerie", testId: "nav-link-galerie" },
  { label: "Confiance", href: "#confiance", testId: "nav-link-confiance" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];

export const NavigationHeader = () => {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-[#1A1714]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand-logo" className="flex flex-col leading-none group">
          <span className="font-serif-display text-2xl font-semibold tracking-tight text-[#1A1714] group-hover:text-[#9E5A38] transition-colors duration-300">
            Louis Larsson
          </span>
          <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#8A7E72] mt-1">
            Peinture · Rénovation
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="relative text-sm font-medium text-[#574E45] hover:text-[#1A1714] transition-colors duration-300 after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#9E5A38] after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-cta-call"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#1A1714] text-[#FAF7F2] px-5 py-2.5 text-sm font-medium hover:bg-[#9E5A38] transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            {CONTACT.phoneDisplay}
          </a>
          <Link
            to="/admin"
            data-testid="nav-admin-login-button"
            aria-label="Espace artisan"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#1A1714]/15 text-[#8A7E72] hover:text-[#1A1714] hover:border-[#1A1714]/40 transition-colors duration-300"
          >
            <Lock className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </motion.header>
  );
};
